import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentDeletedLogEvent = unifiedAgentEvent<{
  agent_id: number
  was_active: boolean
}>('Unified_Agent_Deleted')
